import EventBase from './EventBase'
import EventID from './EventID'


export default class EventNotSelect extends EventBase {
  /**
   * 注释的构造函数
   */
  constructor(param?: string, indent?: number, isText = false) {
    super()
    this.Parameter = param ? [param] : ['']
    indent && (this.Indent = indent)
    this.IsText = isText
  }

  /**
   * 剧情ID
   */
  Code = EventID.NotSelect
  // #region 类的相关绑定参数都在这里
  /**
   * 内容
   */
  get Content() {
    return this.Parameter?.[0] || ''
  }
  set Content(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 标记是否是显示文本的不能选选项
   */

  public IsText: boolean

  // #endregion

  /**
   * 获取显示信息
   */
}
